import type { ThemePreset } from "../types";

export const classic: ThemePreset = {
  id: "classic",
  name: "Klassisch",
  nameKey: "admin.settings.appearance.themes.classic.name",
  description: "Helles, nüchternes Design mit Blaugrau-Tönen",
  descriptionKey: "admin.settings.appearance.themes.classic.description",
  light: {
    background: "oklch(1 0 0)",
    foreground: "oklch(0.145 0 0)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.145 0 0)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.145 0 0)",
    primary: "oklch(0.425 0.126 264)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.96 0.005 264)",
    "secondary-foreground": "oklch(0.205 0.015 264)",
    muted: "oklch(0.96 0.005 264)",
    "muted-foreground": "oklch(0.556 0.015 264)",
    accent: "oklch(0.96 0.005 264)",
    "accent-foreground": "oklch(0.205 0.015 264)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.922 0.005 264)",
    input: "oklch(0.922 0.005 264)",
    ring: "oklch(0.425 0.126 264)",
    "sidebar-background": "oklch(0.985 0 0)",
    "sidebar-foreground": "oklch(0.345 0.015 264)",
    "sidebar-primary": "oklch(0.425 0.126 264)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.96 0.005 264)",
    "sidebar-accent-foreground": "oklch(0.205 0.015 264)",
    "sidebar-border": "oklch(0.922 0.005 264)",
    "sidebar-ring": "oklch(0.425 0.126 264)",
  },
  dark: {
    background: "oklch(0.16 0.006 264)",
    foreground: "oklch(0.92 0.01 264)",
    card: "oklch(0.20 0.008 264)",
    "card-foreground": "oklch(0.92 0.01 264)",
    popover: "oklch(0.20 0.008 264)",
    "popover-foreground": "oklch(0.92 0.01 264)",
    primary: "oklch(0.62 0.126 264)",
    "primary-foreground": "oklch(0.16 0.006 264)",
    secondary: "oklch(0.25 0.015 264)",
    "secondary-foreground": "oklch(0.90 0.01 264)",
    muted: "oklch(0.25 0.012 264)",
    "muted-foreground": "oklch(0.65 0.015 264)",
    accent: "oklch(0.25 0.015 264)",
    "accent-foreground": "oklch(0.92 0.01 264)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.28 0.01 264)",
    input: "oklch(0.28 0.01 264)",
    ring: "oklch(0.62 0.126 264)",
    "sidebar-background": "oklch(0.14 0.006 264)",
    "sidebar-foreground": "oklch(0.82 0.015 264)",
    "sidebar-primary": "oklch(0.62 0.126 264)",
    "sidebar-primary-foreground": "oklch(0.16 0.006 264)",
    "sidebar-accent": "oklch(0.22 0.015 264)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 264)",
    "sidebar-border": "oklch(0.28 0.01 264)",
    "sidebar-ring": "oklch(0.62 0.126 264)",
  },
};
